import React from "react";

import styled from "styled-components/macro";

import classNames from "classnames";

import CircleCheck from "./CircleCheck";

export default function FnrEnrichedCheckbox({
  children,
  on,
  toggleOn,
  disabled,
  loading,
  checkSide = "right",
  style,
  wrapperStyle,
  ...props
}) {
  const onClass = classNames({ on, disabled });

  return (
    <Wrapper
      onClick={disabled ? null : toggleOn}
      className={onClass}
      style={wrapperStyle}
      {...props}
    >
      <Content style={style}>{children}</Content>
      <CheckHolder className={classNames({ left: checkSide === "left" })}>
        <CircleCheck checked={on} />
      </CheckHolder>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 12px 0;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: opacity 0.2s;
  box-sizing: border-box;
  &.disabled {
    opacity: 0.8;
    cursor: not-allowed;
  }
`;

const Content = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  padding-left: 48px;
  order: 2;
`;
const CheckHolder = styled.div`
  margin-left: 12px;
  flex-shrink: 0;
  flex-grow: 0;
  margin-right: 5px;
  order: 3;
  &.left {
    order: 1;
  }
`;

const FnrCheckboxIconStyle = styled.div`
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  align-self: stretch;
  height: 100%;
  left: 0;
  position: absolute;
`;
export const FnrCheckboxText = styled.div`
  width: 100%;
  font-weight: 400;
`;
export const FnrCheckboxSubtext = styled.div`
  width: 100%;
  font-size: 13px;
  color: #384a5d;
  margin-top: 2px;
  line-height: 15px;
`;

export function FnrCheckboxIcon({ className, ...props }) {
  return (
    <FnrCheckboxIconStyle {...props}>
      <div className={className} />
    </FnrCheckboxIconStyle>
  );
}
